import { c as _c } from "react/compiler-runtime";
import RoomAlertOverlay, { type RoomAlertVariant } from '@/app/[locale]/(worlds)/[roomId]/components/RoomAlertOverlay';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useCrossPlatformGatingContext } from '@/context/CrossPlatformGatingContext';
const TrailerAlertOverlay = t0 => {
  const $ = _c(5);
  const {
    setCloseAlert
  } = t0;
  const {
    isPreferredDevice,
    isVoucherCheckPassed
  } = useCheckEnterRoomContext();
  const {
    shouldShowCompatibilityTrailer
  } = useCrossPlatformGatingContext();
  const shouldShowPremiumAlert = isVoucherCheckPassed === false;
  const shouldShowPreferredDeviceAlert = !isPreferredDevice;
  const shouldShowPlatformCompatibilityAlert = shouldShowCompatibilityTrailer;
  if (!shouldShowPremiumAlert && !shouldShowPreferredDeviceAlert && !shouldShowPlatformCompatibilityAlert) {
    return null;
  }
  const variant = shouldShowPremiumAlert ? "premium" : shouldShowPreferredDeviceAlert ? "preferredDevice" : "platformCompatibility";
  let t1;
  if ($[0] !== setCloseAlert) {
    t1 = () => setCloseAlert(true);
    $[0] = setCloseAlert;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== variant) {
    t2 = <RoomAlertOverlay onClose={t1} variant={variant} />;
    $[2] = t1;
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default TrailerAlertOverlay;